import type { ReactNode } from 'react'

interface Props {
  reason?: string
  className?: string
  children: ReactNode
}

export function ActionTooltip({ reason, className = '', children }: Props) {
  return <span
    className={`action-tooltip ${reason ? 'has-reason' : ''} ${className}`.trim()}
    tabIndex={reason ? 0 : undefined}
    aria-label={reason}
  >
    {children}
    {reason && <span className="action-tooltip-bubble" role="tooltip">{reason}</span>}
  </span>
}
